import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const MainWrapper = styled.div`
  display: flex;
  align-items: strech;
  height: 100%;
`;

export const Nav = styled.nav`
  flex-shrink: 0;
  width: 300px;
  z-index: ${(props) => props.theme.zindex.mainNavigation};
`;

export const Main = styled.main`
  flex: 1 1 auto;
  padding: ${size(3)};
  overflow: auto;
  -webkit-overflow-scrolling: touch;

  ${(props) => props.theme.breakpoint.Md} {
    padding: ${size(10)} ${size(5)};
  }
`;
